// extracted by mini-css-extract-plugin
module.exports = {"root":"Empty_root__303RL"};